import React from "react";
import { fmtCurrency } from "../lib/formatters";

// Small ✓/≠ badge shown under a KPI when running in ?dev=1 mode.
export default function AnchorBadge({ actual, expected, digits = 0, testid }) {
  if (expected === undefined || expected === null) return null;
  const diff = actual - expected;
  const pct = expected !== 0 ? (100 * diff) / expected : 0;
  const ok = Math.abs(pct) < 0.1;
  const color = ok ? "#2E7D32" : "#EA6A47";
  const bg = ok ? "#E8F5E9" : "#FDF5F2";
  return (
    <div
      className="mt-1 flex items-center gap-1 text-[9px] font-mono tabular-nums"
      style={{ color, background: bg, padding: "1px 4px", borderRadius: 2, lineHeight: 1.3 }}
      data-testid={testid}
      title={`Expected: ${expected.toLocaleString("en-US", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      })}`}
    >
      <span style={{ fontWeight: 700 }}>{ok ? "✓" : "≠"}</span>
      <span>vs {fmtCurrency(expected, digits)}</span>
      {!ok && (
        <span style={{ opacity: 0.75 }}>
          ({diff >= 0 ? "+" : ""}
          {pct.toFixed(2)}%)
        </span>
      )}
    </div>
  );
}
